import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { Getters, Mutations, Actions, Drivers } from '@/models/Driver.model';

// Inital state
const state: Drivers = {
  activeDrivers: [],
  availableDrivers: [],
  deletedDrivers: [],
  driverTypes: [],
  driverRoutes: [],
};

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, Drivers> = {
  emptyDriver: (state) => {
    // YAY! no complex nested objects to worry about here - https://github.com/vuejs/vue/issues/4292 complex nested objects are not reactive
    return {
      id: 0,
      typeId: 0,
      type: '',
      linkBonus: false,
      name: '',
      nickname: '',
      cellNumber: '',
      idNumber: '',
      pdpExpiry: '',
      hasReceipt: false,
    };
  },

  activeDrivers: (state) => state.activeDrivers,
  availableDrivers: (state) => state.availableDrivers,
  deletedDrivers: (state) => state.deletedDrivers,
  driverTypes: (state) => state.driverTypes,
  driverRoutes: (state) => state.driverRoutes,
};

// TODO: Change mutation names to uppercase ( Standards )
// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, Drivers> = {
  setActiveDrivers(state, { drivers }) {
    state.activeDrivers = drivers;
  },

  setAvailableDrivers(state, { availableDrivers }) {
    state.availableDrivers = availableDrivers;
  },

  setDeletedDrivers(state, { drivers }) {
    state.deletedDrivers = drivers;
  },

  setDriverTypes(state, { driverTypes }) {
    state.driverTypes = driverTypes;
  },

  setDriverRoutes(state, { driverRoutes }) {
    state.driverRoutes = driverRoutes;
  },
};

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, Drivers, Mutations, Getters> = {
  setActiveDrivers({ commit }, payload) {
    commit('setActiveDrivers', payload);
  },

  setAvailableDrivers({ commit }, payload) {
    commit('setAvailableDrivers', payload);
  },

  setDeletedDrivers({ commit }, payload) {
    commit('setDeletedDrivers', payload);
  },

  setDriverTypes({ commit }, payload) {
    commit('setDriverTypes', payload);
  },

  setDriverRoutes({ commit }, payload) {
    commit('setDriverRoutes', payload);
  },
};

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<Drivers, Getters, Mutations, Actions>('DriversModule');

export const DriversModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
